import { useEffect } from "react";
import OrganizationSearch from "./organization-search";
import { useFilterStore } from "../../store";
import { useKeyDown } from "../../hooks";

export default function SearchOverlay({ mode, setMode }: { mode: "expanded" | "collapsed", setMode: (string: "expanded" | "collapsed") => void }) {
    const setFilter = useFilterStore((s) => s.setFilter);

    const handleSubmit = (query: string) => {
        setFilter(query);
        setMode("collapsed");
    };

    const handleOverlayClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
        if(e.target === e.currentTarget) {
            setMode("collapsed");
        }
    };

    useKeyDown((e) => {
       if(mode === "collapsed") {
            e.preventDefault();
            e.stopPropagation();

            setMode("expanded");
        }
    }, ['Escape']);

    return (
        <div className={`search-overlay ${mode}`} onMouseDown={handleOverlayClick}>
            <img
                src={process.env.PUBLIC_URL + "/Logo.svg"}
                alt="Логотип"
                className={`logo ${mode}`}
            />

            <OrganizationSearch
                mode={mode}
                onSubmit={handleSubmit}
                onExpand={() => setMode("expanded")}
                onCollapse={() => setMode("collapsed")}
            />
        </div>
    );
}
